// Past the component loader's retries and the wc-loader's, so a slow load that
// recovers isn't reported as a failure.
export const HEADER_LOAD_TIMEOUT_MS = 15000;
// Both modals render from the store's state as soon as it changes.
export const SIGN_IN_TIMEOUT_MS = 1000;

/**
 * Reports a header failure to Datadog RUM. RUM runs only on pages whose app
 * starts it, so this is a no-op everywhere else.
 *
 * @param {string} message
 * @param {Object} [attributes] - extra context, searchable as @context.*
 */
export const reportHeaderError = (message, attributes) =>
  window.DD_RUM?.addError?.(new Error(message), {
    feature: 'header',
    ...attributes,
  });

/**
 * A chunk failure is already reported by the wc-loader; this reports the
 * result, a header that never rendered. The hydrated class is added in an
 * animation frame, and those don't run in a hidden tab.
 *
 * When the web-components entry never executes (an import of its own that
 * fails, say), nothing defines any component and nothing reports it; this
 * timer is the only signal. That page-wide failure is reported under its own
 * message and feature, so header queries and monitors never count it, and
 * "Header failed to load" means only a header that didn't hydrate on a page
 * whose runtime was up.
 *
 * @param {HTMLElement} header - the va-header-navigation element
 */
export const reportHeaderNotLoaded = header => {
  if (
    document.visibilityState === 'hidden' ||
    header?.classList.contains('hydrated')
  ) {
    return;
  }
  if (window.customElements.get('va-header-navigation')) {
    reportHeaderError('Header failed to load');
  } else {
    reportHeaderError('Web components runtime not loaded', {
      feature: 'web-components',
      reportedBy: 'header',
    });
  }
};

export const reportSignInNotOpened = () => {
  if (!document.querySelector('#signin-signup-modal, #form-sign-in-modal')) {
    reportHeaderError('Header sign in opened no modal');
  }
};
